<div *ngIf="loading" class="overlay d-flex justify-content-center">
  <div class="spinner-border text-primary align-self-center">
  </div>
</div>
<div class="payment-options">
  <h5 class="options-title">
    {{ "modeso_payment_checkout-payment-options_payment-options-caption" | injectedText | async }}</h5>
  <ul>
    <ng-container *ngFor="let paymentOption of paymentOptions$ | async ; let i = index;">
      <li>
        <input type="radio" name="payment-option" id="option-{{i}}"
          [checked]="selectedOption && paymentOption.paymentId === selectedOption.paymentId"
          (change)="onPaymentOptionChanged(paymentOption.paymentId,paymentOption.paymentName)" />
        <label for="option-{{i}}" class="icon">
          <img src="assets/lidl-lib-payment-fe/{{ paymentOption.paymentId | lowercase }}.svg">
        </label>
        <label for="option-{{i}}">{{paymentOption.paymentName}}</label>
      </li>
    </ng-container>
  </ul>
</div>
